import { render } from "./Wellreceived.vue?vue&type=template&id=97e3880a"
import script from "./Wellreceived.vue?vue&type=script&lang=js"
export * from "./Wellreceived.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__